import SummaryPage from './summary.container';

export default SummaryPage;